export const BLOG_POSTS = [
  {
    slug: "geo-vs-seo-2026",
    title: "GEO vs SEO: Why AI Visibility Is the New #1 Ranking Factor",
    excerpt:
      "Google still matters — but Perplexity, ChatGPT and Gemini are quietly becoming the new front page of the internet. Here's how to win both.",
    category: "GEO",
    date: "Mar 18, 2026",
    readTime: "8 min read",
    author: "Matthew Burgess",
    authorRole: "Founder & CEO, EchoWings Media",
    authorBio:
      "Matthew has spent over a decade growing service businesses through search and now leads EchoWings Media's GEO + SEO practice.",
    image:
      "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&q=80&w=1600",
    featured: true,
    body: [
      {
        type: "p",
        text: "For 20+ years, SEO has been the dominant playbook for getting found online. Now, in 2026, something fundamental is shifting — your customers are increasingly skipping Google's blue links and asking AI engines like ChatGPT, Gemini and Perplexity to recommend a business directly.",
      },
      {
        type: "p",
        text: "That shift gave rise to Generative Engine Optimization (GEO) — a discipline that decides whether AI engines mention YOUR business or your competitor's when a buyer asks a high-intent question.",
      },
      { type: "h2", text: "What is GEO, really?" },
      {
        type: "p",
        text: "GEO is the process of structuring your website, content, authority signals and schema so that large-language-model search engines reliably cite you as a trustworthy source. Think of it as SEO's younger, faster-growing sibling — built for a world where AI is the front door to discovery.",
      },
      { type: "h2", text: "Why GEO matters now" },
      {
        type: "list",
        items: [
          "AI-driven search is forecasted to overtake classical search by 2028.",
          "Consumers trust AI citations more than blue-link results in 64% of recent studies.",
          "Citations stick — once an engine picks you as the source, you compound over time.",
          "Most businesses are completely blind to whether they appear in AI answers today.",
        ],
      },
      { type: "h2", text: "The new framework: SEO + GEO" },
      {
        type: "p",
        text: "The mistake we see most agencies make is treating GEO as a replacement for SEO. It isn't. Google still drives the lion's share of high-intent traffic — and the technical work you do for Google (schema, internal links, page speed, authority) is the same foundation AI engines use to evaluate your trustworthiness.",
      },
      {
        type: "p",
        text: "What changes is what you do on top of that foundation. We've moved away from generic keyword stuffing and toward what we call entity-rich content: clearly written, expertly sourced pages with explicit definitions, comparisons, citations and FAQ structure. That format is gold for both Google AND for ChatGPT and Gemini.",
      },
      { type: "h2", text: "5 things to do this week" },
      {
        type: "list",
        items: [
          "Audit how your brand appears in ChatGPT, Gemini and Perplexity (search your own buying-intent queries).",
          "Add comprehensive FAQ schema and Service schema to your top 5 pages.",
          "Build out a comparison page (e.g. 'You vs Competitor X') — AI engines love them.",
          "Earn authoritative external citations: directory listings, podcasts, press, niche mentions.",
          "Set up a monthly process to monitor and measure AI visibility, not just SERP rankings.",
        ],
      },
      { type: "h2", text: "The takeaway" },
      {
        type: "p",
        text: "Search isn't dying — it's splintering. The businesses winning in 2026 are the ones treating SEO and GEO as a unified system, not two separate disciplines. Get the foundation right, and you'll own the next decade of buyer discovery whether they come from Google, ChatGPT or whatever comes next.",
      },
    ],
  },
  {
    slug: "local-seo-roofing-2026",
    title: "The Local SEO Playbook for Roofing Companies in 2026",
    excerpt:
      "Step-by-step framework we used to grow MyRoofNexus 340% YoY — covering GBP, citations, content, links and review velocity.",
    category: "Local SEO",
    date: "Mar 12, 2026",
    readTime: "12 min read",
    author: "Matthew Burgess",
    image:
      "https://images.unsplash.com/photo-1602193230480-7840a38eb0c3?auto=format&fit=crop&q=80&w=1200",
  },
  {
    slug: "what-makes-a-converting-homepage",
    title: "What Makes a Homepage Actually Convert (Backed by Data)",
    excerpt:
      "We tested 12 homepage variants across 6 industries. These 7 patterns showed up in every top-performing variant.",
    category: "CRO",
    date: "Mar 04, 2026",
    readTime: "9 min read",
    author: "Matthew Burgess",
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=1200",
  },
  {
    slug: "google-business-profile-mistakes",
    title: "5 Google Business Profile Mistakes Costing Contractors Leads",
    excerpt:
      "If your GBP is missing these elements, you're handing leads to competitors. Quick fixes that move the needle in 30 days.",
    category: "Local SEO",
    date: "Feb 24, 2026",
    readTime: "6 min read",
    author: "Matthew Burgess",
    image:
      "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&q=80&w=1200",
  },
  {
    slug: "ai-citations-how-to-get-cited",
    title: "How to Get Your Business Cited by ChatGPT, Gemini & Perplexity",
    excerpt:
      "The technical setup, content structure and authority signals that get AI engines to cite your business by name.",
    category: "GEO",
    date: "Feb 14, 2026",
    readTime: "11 min read",
    author: "Matthew Burgess",
    image:
      "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&q=80&w=1200",
  },
  {
    slug: "premium-branding-service-business",
    title: "Why Premium Branding Pays Off (Even for Service Businesses)",
    excerpt:
      "Branding isn't a luxury — it's the cheapest lever to charge 30-50% more and attract better customers.",
    category: "Branding",
    date: "Feb 03, 2026",
    readTime: "7 min read",
    author: "Matthew Burgess",
    image:
      "https://images.unsplash.com/photo-1542744095-fcf48d80b0fd?auto=format&fit=crop&q=80&w=1200",
  },
];

export const getPostBySlug = (slug) => BLOG_POSTS.find((p) => p.slug === slug);
